import { Record } from "appworks/model/gameplay/records/record";

/**
 * Pick Bonus - Use when player picks whilst looking for (n) matches
 */
export class PickMatchRecord extends Record {
    public id = "PickMatchRecord";
    public index: number;
    public value: string | number;
    public isPrize: boolean;
    public complete: boolean;
    public prizeType: string;
}
